import moment from 'moment';
import { takeLatest, select, put } from 'redux-saga/effects';
import { account as accountApis } from '../../api.js';
import { apiSaga } from '../../root-sagas';


export function* doUpgradeBookingsAI({ type, payload: { items, paymentMethod } }) {
  const { coupon } = yield select(state => state.upgrade);
  const { billing: { bookingPaidSubscriptionPrices, bookingFreeTrialSub } } = yield select(state => state.account);
  const activeTrial = bookingFreeTrialSub && bookingFreeTrialSub.status === 'active';
  const trialDays = activeTrial
    ? Math.max(0, moment(bookingFreeTrialSub.cancel_at).diff(new Date(), 'day') || 0)
    : 0;
  const response = yield apiSaga(`${type}_Request`, accountApis.createSubscriptions, [{
    coupon,
    items: items ? items : bookingPaidSubscriptionPrices,
    paymentMethod,
    requireSuccessfulPayment: true,
    trialDays,
  }]);
  if (!response || !['active', 'trialing'].includes(response.subscriptionStatus)) return;
  if (activeTrial) {
    yield apiSaga('Cancel_Subscription', accountApis.cancelSubscriptions, [{
      subscriptionIds: [bookingFreeTrialSub.subscriptionId],
      skipLoader: true,
    }]);
  }
  yield put({ type: `${type}_SUCCESS`, payload: response });
}


function* doUpgradeEmailAssistAI({ type, payload: { items, paymentMethod } }) {
  const { coupon } = yield select(state => state.upgrade);
  const { billing: { emailAssistPaidSubscriptionPrices, emailAssistFreeTrialSub } } = yield select(state => state.account);
  if (emailAssistFreeTrialSub && emailAssistFreeTrialSub.status === 'active') {
    yield apiSaga('Cancel_Subscription', accountApis.cancelSubscriptions, [{
      subscriptionIds: [emailAssistFreeTrialSub.subscriptionId],
      skipLoader: true,
    }]);
  }
  yield apiSaga(type, accountApis.createSubscriptions, [{
    coupon,
    items: items ? items : emailAssistPaidSubscriptionPrices,
    paymentMethod,
    trialDays: emailAssistFreeTrialSub && emailAssistFreeTrialSub.status === 'active'
      ? moment(emailAssistFreeTrialSub.cancel_at).diff(new Date(), 'day')
      : 0,
  }]);
}


function* doUpgradeItineraryAssistAI({ type, payload: { paymentMethod } }) {
  const { coupon } = yield select(state => state.upgrade);
  const { billing: { itineraryAssistPaidPrices, itineraryAssistFreeTrialSub } } = yield select(state => state.account);
  if (itineraryAssistFreeTrialSub && itineraryAssistFreeTrialSub.status === 'active') {
    yield apiSaga('Cancel_Subscription', accountApis.cancelSubscriptions, [{
      subscriptionIds: [itineraryAssistFreeTrialSub.subscriptionId],
      skipLoader: true,
    }]);
  }
  yield apiSaga(type, accountApis.createSubscriptions, [{
    coupon,
    items: itineraryAssistPaidPrices,
    paymentMethod,
    trialDays: itineraryAssistFreeTrialSub && itineraryAssistFreeTrialSub.status === 'active'
      ? moment(itineraryAssistFreeTrialSub.cancel_at).diff(new Date(), 'day')
      : 0,
  }]);
}

function* getCouponInfo({ type }) {
  const { couponCode } = yield select(state => state.upgrade);
  yield apiSaga(type, accountApis.getCouponInfo, [{ couponCode, skipLoader: true }]);
}

function* onUpgradeSuccess(){
  if (window.rewardful) {
    const { user: { email } } = yield select(state => state.account);
    window.rewardful('convert', { email });
  }
}

function* refreshBilling() {
  yield apiSaga('@app/GET_BILLING_INFO', accountApis.getBillingInfo, [{ skipLoader: true }]);
}

export function* refreshAccountInfo() {
  yield apiSaga('@app/GET_ACCOUNT_INFO', accountApis.getAccountInfo, [{ skipLoader: true }]);
}

function* joinAffiliateProgram() {
  // create affiliate if doesn't exist
  const { billing: { affiliate } } = yield select(state => state.account);
  if (!(affiliate && affiliate.id)) {
    yield apiSaga('joinAffiliateProgram', accountApis.joinAffiliate, []);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  takeLatest('bookingsAI_Upgrade', doUpgradeBookingsAI),
  takeLatest('emailAssistAI_Upgrade', doUpgradeEmailAssistAI),
  takeLatest('itineraryAssistAI_Upgrade', doUpgradeItineraryAssistAI),
  takeLatest('upgrade_getCouponInfo', getCouponInfo),
  takeLatest([
    'bookingsAI_Upgrade_SUCCESS',
    'emailAssistAI_Upgrade_SUCCESS',
    'itineraryAssistAI_Upgrade_SUCCESS',
    'joinAffiliateProgram_SUCCESS',
  ], refreshBilling),
  takeLatest('joinAffiliateProgram_SUCCESS', refreshAccountInfo),
  takeLatest([
    'bookingsAI_Upgrade_SUCCESS',
    'emailAssistAI_Upgrade_SUCCESS',
    'itineraryAssistAI_Upgrade_SUCCESS',
  ], onUpgradeSuccess),
  takeLatest([
    'joinAffiliateProgram',
    'bookingsAI_Upgrade_SUCCESS',
    'emailAssistAI_Upgrade_SUCCESS',
    'itineraryAssistAI_Upgrade_SUCCESS',
  ], joinAffiliateProgram),
];
